class FormulaireValidation {

  constructor(){
		this.trigger = document.querySelectorAll('[data-trigger="formulaire-champs"]');
		this.target  = document.querySelector('[data-target="formulaire-champs"]');

		if(this.target){
			this._init();
		}
	}

	_init(){
    for (let element of this.trigger) {
      element.addEventListener('change', (event)=> this._validateForm(event) );
    }
	}

	_validateForm(event){
		this.target.submit();
	}
}
  
export let formulaireValidation = new FormulaireValidation();